$(document).ready(function () {
    $("body").on("click", ".nav-item", function () {
        $(".nav-item").toggleClass("open");
        $(".sidebar").toggleClass("open").parent().toggleClass("expanded");
    });

    $("body").on("click", ".menu-mobile .overlay, .btn-close", function () {
        $(".nav-item").removeClass("open");
        $(".sidebar").removeClass("open").parent().removeClass("expanded");
    });

    $("body").on("click", "li.menu-item-has-children > a", function (e) {
        e.preventDefault();

        const $parent = $(this).parent("li");
        const $submenu = $parent.children("ul.sub-menu, ul.dropdown-menu");

        $parent.siblings(".active").removeClass("active")
        .children("ul.sub-menu, ul.dropdown-menu").slideUp(300);

        $submenu.stop(true, true).slideToggle(300);
        $parent.toggleClass("active");
    });

    $(document).on("click", function (e) {
        if (!$(e.target).closest(".menu, .menu-item-has-children").length) {
            $(".menu-item-has-children.active")
                .removeClass("active")
                .children("ul.sub-menu, ul.dropdown-menu").slideUp(300);
        }
    });
});